import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import { PageIntro } from "@/components/site/PageIntro";
import { PortfolioCard, VideoLightbox } from "@/components/site/Portfolio";
import { Loading, ErrorState, Reveal } from "@/components/site/Primitives";
import { Showreel } from "@/components/site/Showreel";

export default function Work() {
  const [state, setState] = useState({ items: null, error: null });
  const [open, setOpen] = useState(null);
  useSeo("work", "/work");

  useEffect(() => {
    api.get("/public/portfolio")
      .then((r) => setState({ items: r.data, error: null }))
      .catch(() => setState({ items: [], error: "Couldn't load the portfolio." }));
  }, []);

  return (
    <div data-testid="work-page">
      <PageIntro eyebrow="Work" title="From the bay." body="Approved, published work across formats and industries." />
      <div className="eb-container py-12">
        {state.error && <ErrorState message={state.error} />}
        {!state.items && <Loading rows={6} />}
        {state.items && !state.error && state.items.length === 0 && (
          <div className="space-y-8">
            <p className="text-zinc-500">New work is being curated. Ask us for private samples relevant to your brief.</p>
            <div className="-mx-5 sm:-mx-8 lg:-mx-12"><Showreel items={[]} slots={8} /></div>
          </div>
        )}
        <div className="grid gap-4 md:gap-6 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" data-testid="work-grid">
          {(state.items || []).map((item, i) => (
            <Reveal key={item.id} delay={(i % 6) * 0.05}><PortfolioCard item={item} onOpen={setOpen} /></Reveal>
          ))}
        </div>
      </div>
      <VideoLightbox item={open} onClose={() => setOpen(null)} />
    </div>
  );
}
